import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arvr-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  contents = [
    // '<img src="../../../assets/logo_msh@2x.png" alt="" style="width:90px; margin-left:50px">',
    // '<img src="../../../assets/meta-logo-primary_standardsize.svg" alt="" style="width:90px;margin:25px; margin-left:45px;">',
    '<img src="../../../assets/gsv.png" alt="" style="width:174px;margin:9px;padding:4px 8px">',
    '<img src="../../../assets/univo-logo.svg" alt="" style="    width: 136px;margin: 24px;padding: 0px 10px;">',
    '<img src="../../../assets/Incubator.svg" alt="" style="width:174px;margin:9px;padding:4px 8px">'
  ]

  constructor() { }

  ngOnInit(): void {
    let mbLogos = document.getElementById('mb-logos')
    let i = 0;
    mbLogos.innerHTML = this.contents[i];
    setInterval(() => {
      i += 1;
      mbLogos.innerHTML = this.contents[i % 3];
    }, 2000);
  }

}
